import NonProfitPage from './crowdfunding_nonprofit'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { NEW_CAMPAIGN_ID, setData } from 'redux/modules/campaign'
import { getFeaturedCharities } from 'redux/selectors/charity'
import { getCharities } from 'redux/modules/charity'
import { getI18n } from 'client/i18n'
import { getDisclaimerVariables } from 'shared/helpers/helperDisclaimer'

const mapStateToProps = (state, props) => {
  const featuredCharities = getFeaturedCharities(state, props)
  const i18n = getI18n('components/pages/crowdfunding/crowdfunding_nonprofit')
  const countryCode = state.country.country_code
  const disclaimer = i18n(
    `legal_text_gnc_${countryCode}`,
    getDisclaimerVariables({ countryCode, isGnc: true })
  )
  return {
    featuredCharities: featuredCharities,
    disclaimer,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    selectCharity(charity) {
      dispatch(
        setData(NEW_CAMPAIGN_ID, {
          charity: charity,
          npid: charity.nonprofit_id,
        })
      )
      dispatch(
        push({
          pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create-crowdfunding/basics`,
        })
      )
    },
    getCharities(searchParams) {
      return dispatch(getCharities(searchParams))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NonProfitPage)
